import type { SummeryTranslations } from "@/service/translate/summery/SummeryTranslations.types"
import { getCgvLink } from "@/service/legalLinks/legalLinksService"

const cgvUrl = getCgvLink()

const SummeryEnTranslations: SummeryTranslations = {
    "summery": {
        "title": "Detail of my order",
        "included": "Included",
        "confirmationSummaryDetails": "Details of my order",
        "samePrice": "Same price"
    },
    "traveller": {
        "adult": "adult",
        "adult_plural": "adults",
        "child": "child",
        "child_plural": "children"
    },
    "tripSummery": {
        "title": "Your trip",
        "destination": "Destination",
        "dates": "Dates",
        "participants": "Guests",
        "origin": "Leaving from",
        "package": "Package",
        "journey": "Journey"
    },
    "packageSummery": {
        "title": "Package",
        "hsTitle": "Your accommodation",
        "stay": "Accommodation",
        "flight": "Flight",
        "train": "Train",
        "transfers": "Transfers",
        "skiPass": "Ski Pass",
        "equipment": "Equipment",
        "accomodation": "Accommodation details",
        "noskipass": "Ski pass removed from package",
        "noequipment": "Equipment removed from package",
        "valleyNight": "Return Saturday night in Valley"
    },
    "extrasSummery": {
        "title": "Extras",
        "titleCSE": "Your services"
    },
    "priceSummery": {
        "fee": "Booking fees",
        "total": "Total",
        "perPerson": "Per person",
        "payableNow": "Payable Now",
        "payableLater": "Payable on",
        "lastMinuteDiscount": "Last minute sales"
    },
    "paymentCondition": {
        "fix": "Fixed",
        "flex": "Flex",
        "fixLong": "<b>Best price</b>",
        "flexLong": "<b>Flexibility</b>",
        "fixDescription": `Non refundable. Full payment required at point of booking. Modifications of extras not including accommodations according to <a href="${cgvUrl}" target="_blank">terms and conditions.</a>`,
        "flexDescription": `Modifications only possible until cancellation_until,  subject to the <a href="${cgvUrl}" target="_blank">terms and conditions.</a>`,
        // Train-only
        "trainOnlyDescription": `Cancellation and modification according to the <a href="${cgvUrl}" target="_blank" rel="noopener">terms and conditions</a>.`
    },
    "bestPrice": {
        "title": "Best price guarantee",
        "description": "By booking with Travelski, you’re assured the best price guarantee"
    },
    "transferSummery": {
        "title": "Transfers",
        "description": "Transfer to and from the resort",
        "funicularDescription": "Round trip transfer by funicular"
    },
    "familyService": {
        "3": "Ski pass",
        "4": "Hotel services",
        "5": "Food Pack delivery",
        "6": "Insurance",
        "7": "Service provisions",
        "8": "Transport",
        "11": "Restaurant & Board",
        "12": "Ski school",
        "13": "Wellbeing activities",
        "14": "Ski equipment",
        "30": "Helmet",
        "38": "Special offer",
        "40": "After Ski activities",
        "41": "Sport",
        "42": "Theme park",
        "44": "Lazy Sunday",
        "53": "Ski equipment",
        "54": "Ski equipment",
        "55": "Ski equipment",
        "56": "Ski equipment",
        "57": "Ski equipment",
        "63": "Ski equipment",
        "64": "Ski school",
        "65": "Multi-activity pass",
        "66": "Theme park",
        "67": "Luggage storage",
        "68": "Events & Entertainment",
        "69": "Parking",
        "70": "Tourist tax",
        "71": "Sold locally",
        "72": "Biking activities",
        "73": "Return Saturday night in Valley",
        "74": "Hiking & Outdoor activities",
        "75": "Skipass Family Pack",
        "77": "Adrenalin and sensation",
        "78": "Transfer",
        "81": "Flight",
        "82": "Luggage",
        "83": "Transport"
    },
    "priceUpdatedSummery": {
        "priceUpdated": "Price updated on",
        "priceUpdatedDescription": "Price may change based on real-time availability from our suppliers."
    }
}

export default SummeryEnTranslations;